export default function ActivitiesController(
    $scope,
    UrlFactory,
    $location,
    Scroll,
    siteService,
    activities // resolved
) {
    $scope.activities = activities
        .filter((activity) => activity.Level > 0 && activity.ParentID)
        .map((x) => {
            if (x.ThumbURL == null) {
                x.ThumbURL = "images/NoPhoto.gif";
            }
            return x;
        });

    $scope.selectActivity = function (activity) {
        const slug = UrlFactory.slugify(activity.Name);
        $location.path("/activities/" + slug);
    };

    Scroll.to("title-focus", siteService.headerHeight + 15);
}
